import React, { useLayoutEffect } from 'react';
import { ThemeProvider as EmotionThemeProvider, CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { theme } from '@frontend/theme-original';
import { usePrefersReducedMotion } from '../hooks/use-prefers-reduced-motion';
import { ThemeOptionProvider } from '../theme-option-provider';
import { createPrioritizedEmotionCache } from './emotion-linaria-precedence';

const emotionCache = createPrioritizedEmotionCache('css');

type OriginalThemeProviderProps = {
  children?: React.ReactNode;
  includeEmotionTheme?: boolean;
  skipAnimation?: boolean;
};

// Define these in the global scope because theme and root styles
// are consistent instances.

export const OriginalThemeProvider = ({
  children,
  includeEmotionTheme = false,
  skipAnimation,
}: OriginalThemeProviderProps) => {
  useLayoutEffect(() => {
    document.body.setAttribute('data-theme', 'light');
  }, []);

  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <ThemeOptionProvider skipAnimation={prefersReducedMotion || skipAnimation}>
      <EmotionCacheProvider value={emotionCache}>
        {includeEmotionTheme ? (
          <EmotionThemeProvider theme={theme as any}>{children}</EmotionThemeProvider>
        ) : (
          <>{children}</>
        )}
      </EmotionCacheProvider>
    </ThemeOptionProvider>
  );
};
